export const navSections = [
  { id: "toprank", label: "今日热榜", icon: "ri-fire-line" },
  { id: "featured", label: "爆款精选", icon: "ri-flashlight-line" },
  { id: "special", label: "专题盘点", icon: "ri-newspaper-line" },
  { id: "brief", label: "必看快讯", icon: "ri-broadcast-line" },
  { id: "about", label: "关于我们", icon: "ri-information-line" },
];

export const categories = [
  { name: "娱乐", icon: "ri-star-smile-line", count: 328 },
  { name: "综艺", icon: "ri-tv-line", count: 214 },
  { name: "影视", icon: "ri-movie-2-line", count: 267 },
  { name: "音乐", icon: "ri-music-2-line", count: 143 },
  { name: "社会热议", icon: "ri-discuss-line", count: 196 },
  { name: "电竞", icon: "ri-gamepad-line", count: 158 },
];

export const topRank = [
  { rank: 1, title: "热剧收官后，主演集体「破圈营业」成新标配", category: "娱乐", heat: "热议 268万", trend: "up" },
  { rank: 2, title: "选秀十年回望：从全民打投到理性回归，偶像综艺走到哪了", category: "综艺", heat: "热议 214万", trend: "up" },
  { rank: 3, title: "暑期档国片黑马连破票房纪录，口碑如何逆袭", category: "影视", heat: "热议 189万", trend: "new" },
  { rank: 4, title: "顶流歌手巡演开票秒空，「抢票难」再次刷屏", category: "音乐", heat: "热议 162万", trend: "up" },
  { rank: 5, title: "综艺嘉宾「塌房」，品牌为何连夜解约止损", category: "娱乐", heat: "热议 143万", trend: "down" },
  { rank: 6, title: "电竞明星选手转会尘埃落定，新赛季格局生变", category: "电竞", heat: "热议 121万", trend: "up" },
  { rank: 7, title: "硬核纪录短片一夜爆火，纪录片加速走进大众视野", category: "影视", heat: "热议 98万", trend: "new" },
  { rank: 8, title: "短剧「一周一部爆款」，正在重塑内容消费习惯", category: "社会热议", heat: "热议 86万", trend: "up" },
  { rank: 9, title: "古装剧服化道审美升级，被网友逐帧盘点", category: "影视", heat: "热议 74万", trend: "down" },
  { rank: 10, title: "全民健身综艺热，运动题材内容迎来春天", category: "综艺", heat: "热议 61万", trend: "up" },
];

export const featured = [
  {
    id: "f1",
    category: "影视",
    tone: "red",
    title: "口碑与票房双赢背后：这届国片做对了什么",
    summary: "从剧本打磨到排片策略，盘点国产电影口碑发酵的核心路径，以及观众审美正在发生的悄然变化。",
    readTime: 8,
    heat: "爆款 213万",
    tag: "深度盘点",
    image: "https://readdy.ai/api/search-image?query=cinematic%20film%20set%20scene%20with%20warm%20red%20theater%20seats%20and%20film%20projector%20light%20in%20a%20cozy%20cream-toned%20editorial%20room%2C%20warm%20ambient%20glow%2C%20magazine%20editorial%20photography%2C%20high%20detail%2C%20soft%20shadows&width=900&height=640&seq=chigua-feat-01&orientation=landscape",
  },
  {
    id: "f2",
    category: "综艺",
    tone: "green",
    title: "从冷门到顶流，一档慢综艺的破圈方法论",
    summary: "没有剧本冲突也能出圈？拆解慢综艺为何能在快节奏时代俘获大批观众，并带动线下文旅联动。",
    readTime: 6,
    heat: "热议 186万",
    tag: "趋势观察",
    image: "https://readdy.ai/api/search-image?query=cozy%20lifestyle%20reality%20show%20scene%20with%20warm%20wooden%20kitchen%20table%20and%20green%20plants%20and%20soft%20natural%20window%20light%2C%20warm%20editorial%20photography%2C%20inviting%20relaxed%20mood%2C%20high%20detail&width=900&height=640&seq=chigua-feat-02&orientation=landscape",
  },
  {
    id: "f3",
    category: "音乐",
    tone: "amber",
    title: "一场演唱会的热度，为何能持续一整周",
    summary: "从舞台设计到社交媒体二创，音乐演出如何构建现象级热度，为城市文旅注入新的活力。",
    readTime: 5,
    heat: "热议 154万",
    tag: "现场纪实",
    image: "https://readdy.ai/api/search-image?query=live%20concert%20stage%20with%20warm%20golden%20spotlights%20and%20crowd%20silhouettes%20and%20floating%20light%20particles%2C%20energetic%20editorial%20music%20photography%2C%20rich%20warm%20tones%2C%20high%20detail&width=900&height=640&seq=chigua-feat-03&orientation=landscape",
  },
  {
    id: "f4",
    category: "社会热议",
    tone: "red",
    title: "「吃瓜文化」进化论：围观者的双面角色",
    summary: "从围观到参与再到理性吃瓜，探讨热点事件中情绪、立场与事实之间的微妙平衡。",
    readTime: 7,
    heat: "热议 132万",
    tag: "观点专栏",
    image: "https://readdy.ai/api/search-image?query=modern%20editorial%20flat-lay%20with%20smartphones%20showing%20social%20feeds%20and%20fresh%20watermelon%20slices%20on%20warm%20cream%20background%20with%20subtle%20red%20and%20green%20accents%2C%20clean%20magazine%20photography%2C%20high%20detail&width=900&height=640&seq=chigua-feat-04&orientation=landscape",
  },
  {
    id: "f5",
    category: "电竞",
    tone: "green",
    title: "老将焕新 vs 新人上位，转会期全梳理",
    summary: "新赛季阵容大洗牌，哪支战队的引援最被看好，粉丝视角的期待与担忧都在这。",
    readTime: 6,
    heat: "热议 107万",
    tag: "竞技前线",
    image: "https://readdy.ai/api/search-image?query=esports%20arena%20scene%20with%20glowing%20monitors%20and%20gaming%20keyboards%20and%20green%20and%20warm%20accent%20lighting%2C%20modern%20editorial%20sports%20photography%2C%20high%20detail%2C%20dark%20clean%20background&width=900&height=640&seq=chigua-feat-05&orientation=landscape",
  },
  {
    id: "f6",
    category: "娱乐",
    tone: "amber",
    title: "艺人经纪的「避坑指南」：合作之前看什么",
    summary: "从合约条款到危机应对，梳理当下内容合作中值得关注的行业常识，为理性围观提供参考。",
    readTime: 9,
    heat: "热议 88万",
    tag: "行业解析",
    image: "https://readdy.ai/api/search-image?query=editorial%20scene%20of%20star%20shaped%20award%20trophy%20and%20velvet%20red%20ribbon%20on%20warm%20beige%20studio%20background%20with%20soft%20light%20and%20subtle%20green%20plant%2C%20luxury%20magazine%20photography%2C%20high%20detail&width=900&height=640&seq=chigua-feat-06&orientation=landscape",
  },
];

export const specials = [
  {
    no: "S01",
    series: "深度专题",
    tag: "年度出圈名场面",
    title: "那些刷屏全网的「出圈时刻」，是怎么被记住的",
    summary: "一句台词、一个动作、一段反转，盘点今年真正打动人心的出圈瞬间，还原它们从片段走向全民记忆的全过程，也看看台前幕后不为人知的细节。",
    episode: "已更新 8 期 · 连载中",
    image: "https://readdy.ai/api/search-image?query=dramatic%20theater%20spotlight%20stage%20with%20red%20velvet%20curtain%20and%20warm%20golden%20light%20particles%20in%20dark%20elegant%20theater%20hall%2C%20cinematic%20editorial%20photography%2C%20rich%20warm%20red%20tones%2C%20high%20detail&width=1200&height=760&seq=chigua-special-01&orientation=landscape",
  },
  {
    no: "S02",
    series: "系列栏目",
    tag: "这个综艺怎么火的",
    title: "从立项到出圈，一档综艺的「爆红密码」",
    summary: "为什么有的综艺开播即巅峰，有的口碑逆袭？编辑部拆解选角、剪辑、营销与观众的化学反应，用一个个真实案例讲清楚现象级综艺的养成逻辑。",
    episode: "已更新 6 期 · 更新中",
    image: "https://readdy.ai/api/search-image?query=bright%20colorful%20television%20studio%20set%20with%20warm%20lights%20and%20confetti%20and%20audience%20silhouettes%2C%20energetic%20editorial%20magazine%20photography%2C%20warm%20amber%20and%20red%20tones%2C%20high%20detail&width=1200&height=760&seq=chigua-special-02&orientation=landscape",
  },
  {
    no: "S03",
    series: "趋势研究",
    tag: "内容消费新浪潮",
    title: "短剧、直播与二创：内容的下一个风口在哪",
    summary: "当注意力越来越碎片，什么样的内容能真正留住人？从短剧到直播到用户共创，梳理正在发生的行业变化，帮你看懂内容消费的新方向。",
    episode: "已更新 5 期 · 企划中",
    image: "https://readdy.ai/api/search-image?query=modern%20content%20studio%20with%20large%20screens%20and%20creators%20workspace%20warm%20cream%20and%20green%20accents%20and%20soft%20daylight%2C%20futuristic%20editorial%20photography%2C%20high%20detail%2C%20clean%20composition&width=1200&height=760&seq=chigua-special-03&orientation=landscape",
  },
];

export const briefs = [
  { time: "09:40", tag: "影视", text: "新片定档与票房预测：本周最值得期待的三部作品前瞻" },
  { time: "08:15", tag: "娱乐", text: "某热播剧导演回应结局争议，谈创作取舍与观众反馈" },
  { time: "07:30", tag: "综艺", text: "一档新音综官宣阵容，首期录制路透引发热议" },
  { time: "06:55", tag: "社会热议", text: "「假期出游」相关话题升温，文旅数据同步走高" },
  { time: "05:20", tag: "电竞", text: "战队青训新人首秀表现出色，未来之星浮现" },
  { time: "00:30", tag: "音乐", text: "本周新歌上架，多家乐评平台给出高分评价" },
];

export const faqs = [
  {
    q: "吃瓜日报多久更新一次？",
    a: "吃瓜日报每天更新今日热榜，重要话题与爆款事件会即时跟进；同时我们会定期推出深度专题盘点，方便你在合适的时间集中阅读。",
  },
  {
    q: "热榜排行是怎么来的？",
    a: "热榜排行综合了话题的讨论热度、传播速度与影响力，由编辑部结合多渠道信源综合生成，帮助你快速定位当天最受关注的内容。",
  },
  {
    q: "如何投稿或提供线索？",
    a: "欢迎通过页面底部的订阅表单或邮箱与我们联系。编辑部会评估每一条线索的真实性与价值，并通过必看快讯与专题栏目持续跟进。",
  },
  {
    q: "内容是否可以免费阅读与转发？",
    a: "吃瓜日报的内容面向全网免费阅读，欢迎在标注来源的前提下分享转发；如需转载或商业合作，请提前与我们取得联系。",
  },
];

export const voices = [
  { name: "追剧的猫", role: "忠实读者 · 追更 1 年", text: "每天通勤看热榜已经成了习惯，盘点写得清楚，比我一个个刷群聊省事多了。", initials: "猫" },
  { name: "Lemon酱", role: "综艺爱好者", text: "「这个综艺怎么火的」那个系列真不错，讲透了很多我追过的节目，比纯看热闹有营养。", initials: "柠" },
  { name: "阿北", role: "影视从业者", text: "作为同行也在关注这里的内容结构，观点扎实、信源标注清楚，专业度在同类型里算得上优秀。", initials: "北" },
  { name: "七月的风", role: "新读者", text: "第一次来就把必看快讯翻完了，节奏舒服不注水，已经收藏起来每天追。", initials: "风" },
];

export const stats = [
  { value: "1200+", label: "累计盘点专题" },
  { value: "860万+", label: "全网阅读量" },
  { value: "6 大", label: "垂直内容栏目" },
  { value: "365 天", label: "全年每日更新" },
];